/** Design basis of a /project/bom download, read from its response headers. */
export interface BomBasis {
  basis: string;
  versionId: string;
}

export function bomBasisFromHeaders(headers: any): BomBasis | null {
  const get = (k: string) => (headers && (typeof headers.get === 'function' ? headers.get(k) : headers[k.toLowerCase()])) || '';
  const basis = String(get('X-UGP-BOM-Basis') || '');
  if (!basis) return null;
  return { basis, versionId: String(get('X-UGP-Version-Id') || '') };
}

export function describeBomBasis(b: BomBasis | null): string {
  if (!b) return '';
  if (b.basis === 'approved') return `Built from approved version ${b.versionId}.`;
  if (b.basis === 'latest_fallback') return 'No approved version: built from the latest version (see the Design Basis note in the file).';
  return `Built from the open session${b.versionId ? ` (version ${b.versionId})` : ''}.`;
}
